<script lang="ts">
export type PlacementMenuPick = 'settings' | 'delete'
</script>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { MarMenuItem } from '@nimling/components-nimtech'

const emit = defineEmits<{ close: [pick?: PlacementMenuPick] }>()

const onKey = (e: KeyboardEvent) => {
  if (e.key.toLowerCase() !== 'd' || e.metaKey || e.ctrlKey || e.altKey) return
  e.preventDefault()
  emit('close', 'delete')
}

onMounted(() => window.addEventListener('keydown', onKey))
onBeforeUnmount(() => window.removeEventListener('keydown', onKey))
</script>

<template>
  <div class="mar-menu">
    <MarMenuItem icon="settings" label="Placement settings" @select="emit('close', 'settings')" />
    <MarMenuItem icon="trash" severity="danger" label="Delete" shortcut="D" @select="emit('close', 'delete')" />
  </div>
</template>
